module.exports = __webpack_public_path__ + "static/img/banner.e574954.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mercury/banner.jpg
// module id = q/RL
// module chunks = 0